import { Tooltip } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { FullPresenceT } from 'lib-shared-legacy-types';

import { PresenceAgentV2, WorkloadLimits } from 'apis/presence';
import { TeamChannelIcon } from 'components/teamPageLegacy/components/teamChannelIcon';

import { PresencePopover } from '../presencePopover';
import { getConversationGroups } from '../utils';

import styles from './teamChannelIconsList.module.scss';

type PropsT = {
  fullPresence?: FullPresenceT;
  limits: WorkloadLimits;
  isSimultaneousRingingActive: boolean;
} & Pick<PresenceAgentV2, 'workloads_by_channel'>;

export const TeamChannelIconsList = ({
  workloads_by_channel: workloads,
  fullPresence,
  limits,
  isSimultaneousRingingActive,
}: PropsT): JSX.Element => {
  const hasPresenceAccess = useHasAccess(
    [
      'organization.member.presence.status',
      'organization.member.presence.working_media',
    ],
    { strategy: 'any' },
  );

  const conversationGroups = getConversationGroups(
    workloads,
    limits,
    fullPresence,
  );

  return (
    <>
      {conversationGroups.map(
        ({ id, icon, conversationCount, active, channels, tooltipContent }) =>
          channels.length > 0 && (
            <Tooltip
              key={id}
              wrapProps={{ className: styles.tooltipWrapper }}
              content={tooltipContent}
            >
              <TeamChannelIcon
                icon={icon}
                numberOfConversations={conversationCount}
                active={active}
              />
            </Tooltip>
          ),
      )}
      <TeamChannelIcon
        icon="simultaneous"
        active={isSimultaneousRingingActive}
      />
      {hasPresenceAccess && fullPresence && (
        <PresencePopover
          user={fullPresence.user}
          presence={fullPresence.presence}
        />
      )}
    </>
  );
};
